import styled from 'styled-components';

import { UpdateMessage } from 'libs/ui';

export const Content = styled.div`
  width: 590px;
  position: relative;
  form > div:last-child {
    margin-top: 20px;
  }
`;

export const UpdateMessageStyled = styled(UpdateMessage)`
  bottom: -40px;
  left: 100px;
  z-index: 1;
`;

export const Title = styled.p`
  border-bottom: solid 1px #595d64;
  padding: 0 0 15px 0;
  font-size: 20px;
  color: #fff;
  opacity: 0.6;
`;